import script from "./QuizFuckOff.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizFuckOff.vue?vue&type=script&setup=true&lang=js"

import "./QuizFuckOff.vue?vue&type=style&index=0&id=5d134844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d134844"]])

export default __exports__